var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdmin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "512px",
    height: "512px",
    viewBox: "0 0 24 24",
    fill: "white",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 10.0737C7.47142 10.0449 8.05259 10 8.8 10H15.2C15.9474 10 16.5286 10.0449 17 10.0737M7 10.0737C6.41168 10.1096 5.99429 10.1904 5.63803 10.3719C5.07354 10.6595 4.6146 11.1185 4.32698 11.683C4 12.3247 4 13.1648 4 14.8449V16.2449C4 17.9251 4 18.7652 4.32698 19.4069C4.6146 19.9714 5.07354 20.4303 5.63803 20.7179C6.27976 21.0449 7.11984 21.0449 8.8 21.0449H15.2C16.8802 21.0449 17.7202 21.0449 18.362 20.7179C18.9265 20.4303 19.3854 19.9714 19.673 19.4069C20 18.7652 20 17.9251 20 16.2449V14.8449C20 13.1648 20 12.3247 19.673 11.683C19.3854 11.1185 18.9265 10.6595 18.362 10.3719C18.0057 10.1904 17.5883 10.1096 17 10.0737M7 10.0737V8.04492C7 5.2835 9.23858 3.04492 12 3.04492C14.7614 3.04492 17 5.2835 17 8.04492V10.0737M10 18L10.2857 17M14 18L13.7143 17M10.2857 17L10.8308 15.0922C11.1799 13.8702 11.3545 13.2592 11.6244 13.1058C11.8573 12.9733 12.1427 12.9733 12.3756 13.1058C12.6455 13.2592 12.8201 13.8702 13.1692 15.0922L13.7143 17M10.2857 17H13.7143",
    stroke: "none",
    strokeWidth: 0
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdmin);
export default __webpack_public_path__ + "static/media/admin.32005227435f7ff3eabbf6808b4be3a3.svg";
export { ForwardRef as ReactComponent };